module.exports = __webpack_public_path__ + "img/FishingBob2_DG.8ba9334a.png";